import * as O from "fp-ts/Option";
import { PendingData } from "lib/at-data/AsyncData";
import { ReportsState } from "./state";

export const initialState: ReportsState = {
  reports: PendingData(O.none),
};
